
		<cache-date></cache-date>

		<period></period>

		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

		<hr/>

		<chart [data]="accumFirst.data" [options]="accumFirst.options" [sextant]="'accum'"></chart>

		<hr/>

		<chart [data]="moneyChart.data" [options]="moneyChart.options" (onFilterChange)="updateData($event, 'money')" [sextant]="'money'"></chart>

		<hr/>

		<chart [data]="amountPeriodChart.data" [options]="amountPeriodChart.options" (onFilterChange)="updateData($event, 'period')" [sextant]="'amount-period'"></chart>

		<div class="alert alert-info" role="alert">
			<ul>
				<li>
					Вечный тариф, который сделан как оплата на 100 лет, тут учитывается как на 120 месяц (10 лет)
				</li>
				
				<li>
					Вечный тариф, оплаченый токенами - исключён
				</li>
			</ul>
		</div>

		<hr/>

		<chart [data]="accumSecondPaidChart.data" [options]="accumSecondPaidChart.options" [sextant]="'accum-second-manual'"></chart>

		<hr/>

		<chart [data]="secondManualChart.data" [options]="secondManualChart.options"></chart>
	